"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var filterChecked = function filterChecked(a) {
  return a.checked;
};

var filterUnchecked = function filterUnchecked(a) {
  return !a.checked;
};

var Entries = function Entries(_ref) {
  var activeGroup = _ref.activeGroup,
      intl = _ref.intl,
      options = _ref.options,
      label = _ref.label,
      handleChange = _ref.handleChange,
      handleMultiChange = _ref.handleMultiChange;
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-group-select__entries')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-group-select__entries__head')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-group-select__entries__head__count')
  }, void 0, intl.formatMessage(_messages["default"].selectedItems, {
    count: options.filter(filterChecked).length,
    of: options.length,
    label: label
  })), options.length > 0 && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-group-select__entries__head__action')
  }, void 0, options.filter(filterChecked).length === options.length ? /*#__PURE__*/_jsx("span", {
    onClick: handleMultiChange.bind(_this, options.filter(filterChecked))
  }, void 0, intl.formatMessage(_messages["default"].unselectAll)) : /*#__PURE__*/_jsx("span", {
    onClick: handleMultiChange.bind(_this, options.filter(filterUnchecked))
  }, void 0, intl.formatMessage(_messages["default"].selectAll)))), /*#__PURE__*/_jsx("ul", {
    className: cx('xsui-group-select__entries__list')
  }, void 0, options.map(function (option, i) {
    return /*#__PURE__*/_jsx("li", {}, "".concat(activeGroup, "@@").concat(option.value, "@@").concat(i), /*#__PURE__*/_jsx(_checkbox["default"], {
      name: "entries.".concat(option.value),
      label: option.label,
      input: {
        value: option.checked,
        onChange: handleChange.bind(_this, option)
      }
    }));
  })));
};

var _default = (0, _reactIntl.injectIntl)(Entries);

exports["default"] = _default;